import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const Return = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path
                fill={color}
                d="M14.4,10.3c0-0.4-0.3-0.3-0.6-0.6s-0.3-0.3-0.6-0.5c-0.3-0.3-0.4-0.2-0.6-0.5S12.4,7.8,12.1,8
            	c-0.4,0.2,0,0.4,0,0.9c0,0.4,0.3,0.5,0,0.8c-0.3,0.3-0.4,0-0.9,0c-0.5,0-0.5,0-0.9,0c-0.5,0-0.5,0-0.9,0c-0.5,0-0.5,0.1-0.9,0.1
            	C8,9.8,8,9.7,7.6,9.7c-0.5,0-0.6,0.4-0.9,0C6.3,9.3,6.7,9.2,6.7,8.7c0-0.5,0.3-0.6-0.1-1c-0.3-0.3-0.6-0.3-0.9,0
            	c-0.3,0.4-0.1,0.5-0.1,1c0,0.5,0.1,0.5,0.1,1c0,0.6-0.4,0.7-0.1,1.1c0.3,0.4,0.5,0,0.9,0c0.5,0,0.5,0,0.9,0c0.5,0,0.5-0.1,0.9-0.1
            	c0.5,0,0.5,0,0.9,0s0.5,0,0.9,0c0.5,0,0.5,0.1,0.9,0.1c0.5,0,0.6-0.3,0.9,0c0.3,0.3,0.1,0.4,0,0.8s-0.4,0.7-0.1,0.8
            	c0.3,0.2,0.2-0.3,0.5-0.6c0.3-0.3,0.3-0.3,0.5-0.6c0.3-0.3,0.3-0.3,0.6-0.5C14.2,10.6,14.4,10.7,14.4,10.3z"
            />
        </g>
    </svg>
);

Return.propTypes = propTypes;
Return.defaultProps = defaultProps;

export default Return;
